<div class="log-controls">
  <div class="log-controls-header">
    <h3>Developer Logging Controls</h3>
    <p class="description">
      Control log verbosity for different parts of the application.
      Changes are saved and persist across sessions.
    </p>
  </div>

  <!-- Backend streaming options -->
  <div class="streaming-options">
    <app-checkbox [ngModel]="showTabIdEnabled()" (ngModelChange)="toggleShowTabId($event)"
      label="Include tab ID in backend log prefix (for multi-tab debugging)"
      data-testid="show-tab-id-checkbox" />
  </div>

  <!-- Set all namespaces -->
  <div class="global-control">
    <label for="set-all-level">
      <strong>Set All Namespaces</strong>
      <span class="hint">Quickly set all namespaces to the same level</span>
    </label>
    <app-select>
      <select id="set-all-level" name="set-all-level" #setAllSelect
        (change)="setAllLevels($any($event.target).value); setAllSelect.value = ''">
        <option value="" disabled selected>Select level to apply to all...</option>
        @for (level of levels; track level) {
        <option [value]="level">{{ level }}</option>
        }
      </select>
    </app-select>
  </div>

  <!-- Add custom namespace -->
  <div class="custom-namespace-control">
    <label for="custom-namespace">
      <strong>Add Custom Namespace</strong>
      <span class="hint">Add a specific namespace for debugging (e.g., "org-switch", "database-init")</span>
    </label>
    <div class="custom-namespace-input">
      <input type="text" id="custom-namespace" [value]="customNamespace()"
        (input)="customNamespace.set($any($event.target).value)" (keyup.enter)="addCustomNamespace(customNamespace())"
        placeholder="Enter namespace name..." />
      <button type="button" class="btn-add" (click)="addCustomNamespace(customNamespace())"
        [disabled]="!customNamespace().trim()">
        Add
      </button>
    </div>
  </div>

  <!-- Individual namespace controls -->
  <div class="namespace-controls">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
      <h4 style="margin: 0;">Namespace-Specific Levels</h4>
      @if (allNamespaces().length > 0) {
      <app-input [leadingIcon]="'search'" [trailingIcon]="'x'" [trailingIconHidden]="!searchTerm()"
        (trailingIconClick)="clearSearch()">
        <input type="text" placeholder="Search namespaces..." [(ngModel)]="searchTermValue"
          (input)="onSearchInput($event)" />
      </app-input>
      }
    </div>
    <div class="namespace-grid">
      <div class="namespace-header">
        <span>Namespace</span>
        <span>Level</span>
      </div>
      @for (namespace of filteredNamespaces(); track namespace) {
      <div class="namespace-row">
        <label [for]="'level-' + namespace" class="namespace-label">
          <code>{{ namespace }}</code>
        </label>
        <app-select>
          <select [id]="'level-' + namespace" [name]="'level-' + namespace" [ngModel]="getLevel(namespace)"
            (ngModelChange)="setLevel(namespace, $event)">
            @for (level of levels; track level) {
            <option [value]="level">{{ level }}</option>
            }
          </select>
        </app-select>
      </div>
      }
    </div>
  </div>

  <!-- Help text -->
  <div class="help-section">
    <h4>Log Levels</h4>
    <p class="description">All namespaces default to <strong>silent</strong>. Enable the ones you need.</p>
    <ul class="level-descriptions">
      <li><strong>trace:</strong> Most verbose - all log messages including traces</li>
      <li><strong>debug:</strong> Debug information useful during development</li>
      <li><strong>info:</strong> General informational messages</li>
      <li><strong>warn:</strong> Warning messages</li>
      <li><strong>error:</strong> Error messages only</li>
      <li><strong>silent:</strong> No log output (default)</li>
    </ul>
  </div>
</div>